// extracted by mini-css-extract-plugin
export var closeButton = "_i5-1";
export var closeX = "_i5-3";
export var container = "_i5-0";
export var image = "_i5-2";